import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './payment.json';

const queryPaymentInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['paymentController/queryPaymentInfo'].success.default)));
};

const queryBankInfoList = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['paymentController/queryBankInfoList'].success.default)));
};

const queryInvoiceInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['paymentController/queryInvoiceInfo'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('paymentController/queryPaymentInfo'), withScenario(withAuthCheck(queryPaymentInfo))),
  rest.post(getApiEndpoint('paymentController/queryBankInfoList'), withScenario(withAuthCheck(queryBankInfoList))),
  rest.post(getApiEndpoint('paymentController/queryInvoiceInfo'), withScenario(withAuthCheck(queryInvoiceInfo))),
];
